import React from 'react';
import TabContainer from '../TabContainer';
import TabToolsContainer from '../TabToolsContainer';
import { SearchInput, GroupView, IconButton, BodySectionContainer } from 'components';
import TabBodyContainer from '../TabBodyContainer';
import { inject } from 'mobx-react';
import { EDITOR_GROUPS_STORE, EDITOR_LOCATIONS_STORE } from 'store';
import { observer } from 'mobx-react-lite';
import { icons } from 'assets';
import styles from './ShotsTab.module.scss';
import LocationView from './LocationVew';
import { ShotsTabProps } from './types';

const ShotsTab = (props: ShotsTabProps) => {
  const {
    [EDITOR_GROUPS_STORE]: {
      sortedGroupsList,
      switchAllGroupSelection
    },
    [EDITOR_LOCATIONS_STORE]: {
      locationsForShotsTab
    }
  } = props;
  const [searchText, setSearchText] = React.useState('');

  return (
    <TabContainer>
      <TabToolsContainer>
        <SearchInput onChange={setSearchText} />
        <IconButton
          icon={icons.success}
          title='Select all groups'
          onClick={() => {
            switchAllGroupSelection(false)
            localStorage.setItem('isReadyForAutoGenerateBox', 'true') // For Showing Auto Generate Box
            window.dispatchEvent(new Event('local-storage-change')) // Emit the custom local-storage-change event for real-time changes
          }
          }
          className={styles.iconBttn}
        />
        <IconButton
          icon={icons.error}
          title='Deselect all groups'
          onClick={() => {
            switchAllGroupSelection(true)
            localStorage.removeItem('isReadyForAutoGenerateBox')
            window.dispatchEvent(new Event('local-storage-change')) // Emit the custom local-storage-change event for real-time changes
          }}
          className={styles.iconBttn}
        />
      </TabToolsContainer>
      <TabBodyContainer>
        <BodySectionContainer title='locations'>
          {locationsForShotsTab.map(location =>
            <LocationView
              key={location.name}
              {...location}
            />
          )}
        </BodySectionContainer>
        <BodySectionContainer title='groups'>
          {sortedGroupsList.map(group => {
            if (!group.name.toLowerCase().includes(searchText.trim().toLocaleLowerCase())) return null;
            return (
              <GroupView
                key={group.name}
                {...group}
              />
            );
          })}
        </BodySectionContainer>
      </TabBodyContainer>
    </TabContainer>
  );
};

export default inject(EDITOR_GROUPS_STORE, EDITOR_LOCATIONS_STORE)(observer(ShotsTab));
